module.exports = __webpack_public_path__ + "img/car_0.2fc02338.png";